const AddPatientStyles = {
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: "center",
        alignItems: "center",
    },
    title: {
        fontFamily: 'Kalameh',
        fontSize: '16px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: 'normal',
        textAlign: 'center',
        color: '#3CC0C3',
        margin: 0
    },
    lineProfile: {
        width: '60%',
        height: '2.86px',
        margin: '14px auto',
        background: '#F9FAFB',
        boxShadow: '-0.2px -0.5px 1px #FFFFFF, 0.5px 0.75px 1px rgba(174, 174, 192, 0.6)',
        borderRadius: '2px',
    },
    ButtonStyle: {
        display: "flex !important",
        justifyContent: "center !important",
        alignItems: "center !important",
        height: '48px',
        width: '100%',
        boxShadow: '-6px -6px 30px #FFFFFF, 6px 6px 30px rgba(174, 174, 192, 0.4) !important',
        border: '1px solid #ffffff !important',
        backgroundColor: '#f4f4f4',
        textAlign: 'center',
        borderRadius: '16px !important',
        margin: "auto !important",
        marginTop: "30px !important",
        marginBottom: "30px !important",
        color: '#753cbe',
    },
    ButtonLabel: {
        fontFamily: 'Kalameh',
        fontSize: '14px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        color: '#753cbe !important'
    },
    containerForm: {
        position: 'relative',
        justifyContent: 'center',
        alignContent: 'center',
        // margin: 'auto 50px auto !impor',
        backgroundColor: '#f4f4f4',
        padding: '24px 24px 10px',
        border: '1px solid #FFFFFF',
        boxShadow: '10px 10px 30px 0px #FFFFFF, 10px 10px 30px 0px #AEAEC066',
        borderRadius: '20px'
    },
    TextRoot: {
        height: '48px',
        textAlignLast: 'center',
        "& .MuiOutlinedInput-input": {
            color: "#707070",
        },
        "& .MuiInputLabel-root": {
            color: "#707070"
        },
        "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
            border: 'none'
        },
        "&:hover .MuiOutlinedInput-input": {
            color: "#707070",

        },
        "&:hover .MuiInputLabel-root": {
            color: "#707070"
        },
        "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
            borderColor: "red"
        },
        "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-input": {
            color: "purple"
        },
        "& .MuiInputLabel-root.Mui-focused": {
            color: "purple"
        },
        "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: "purple"
        }
    },
    placeholder: {
        color: "#c2c2c2",
    },
    font: {
        fontFamily: 'Kalameh !important',
        fontSize: '16px !important',
        fontWeight: 'bold !important',
        color: '#753cbe !important'
    },
    item: {
        display: "flex !important",
        justifyContent: "center !important",
        alignItems: "center !important",

    },
    dialogText: {
        display: "flex !important",
        justifyContent: "center !important",
        alignItems: "center !important",
        color: '#d81d5d !important',
        fontFamily: 'Kalameh !important',
        fontSize: '16px !important',
        fontWeight: 'bold !important'
    },
    dialogLongText: {
        display: "flex !important",
        justifyContent: "center !important",
        alignItems: "center !important",
        color: '#222222 !important',
        fontFamily: 'Kalameh !important',
        fontSize: '14px !important',
        fontWeight: 'bold !important',
        textAlign: 'center'
    },
    buttonContainer: {
        display: "flex !important",
        justifyContent: "center !important",
        alignItems: "center !important",
    },
    dialogButton: {
        width: '80% !important',
        borderRadius: '14px !important',
        boxShadow: '-4px -4px 15px 0 #ffffff, 4px 4px 15px 0 rgba(172, 172, 172, 0.5) !important',
        backgroundColor: '#ffffff !important',
        border: '1px solid #ebebeb !important',
        fontWeight: 'bold !important',
        fontFamily: 'Kalameh !important',
        fontSize: '12px !important',
        padding: " 10px 23px !important"
    },
    DialogNFCText: {
        display: "flex !important",
        justifyContent: "center !important",
        alignItems: "center !important",
        fontSize: "14px",
        fontFamily: 'Kalameh',
        textAlign: "center",
        color: '#222222',
        fontWeight: 'bold'
    },
    dialogSuccessText: {
        display: "flex !important",
        justifyContent: "center !important",
        alignItems: "center !important",
        fontSize: "14px !important",
        fontFamily: 'Kalameh !important',
        textAlign: "center !important",
        color: '#3bba4c !important',
        fontWeight: 'bold !important',
        paddingTop: '30px'
    },
    dialogErrorText: {
        display: "flex !important",
        justifyContent: "center !important",
        alignItems: "center !important",
        fontSize: "14px !important",
        fontFamily: 'Kalameh !important',
        textAlign: "center !important",
        color: '#d81d5d !important',
        fontWeight: 'bold !important',
        paddingTop: '30px'
    }
};

export default AddPatientStyles;
